import React from "react"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { useAppContext } from "components/AppContext"

const DataQualityWorkplaceChartOrganism = () => {
  const { pillarId: urlPillarId } = useParams()
  const { envCollect } = useAppContext()

  const dashboardAlias = envCollect?.has_all_workplace_equipment_leased
    ? "dashboard_dataquality_workplace_leased"
    : "dashboard_dataquality_workplace"

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule verdikt_alias={dashboardAlias} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataQualityWorkplaceChartOrganism
